import organizationicon from '../../../assets/Images/org icon.png'
import rolesicon from '../../../assets/Images/roles icon.png'
import kpiicon from '../../../assets/Images/Vector (3).png'
import plansicon from '../../../assets/Images/mdi_file-report-outline.png'
import integrationsicon from '../../../assets/Images/Ebene 2.png'
import usericon from '../../../assets/Images/users icon.png'
import teamicon from '../../../assets/Images/Teams icon.png'



export const menuList = ['Organization', 'Roles', 'KPI', 'Integrations', 'Users', 'Teams', 'ReportLog']

export const menuConfig = {
    Organization: { title: "Organization", url: '/home/organization', icon: organizationicon },
    Roles: { title: "Roles", url: '/home/roles', icon: rolesicon, },
    KPI: { title: "KPI", url: '/home/kpi', icon: kpiicon },
    Integrations: { title: "Integrations", url: '/home/integration', icon: integrationsicon },
    Users: { title: "Users", url: '/home/users', icon: usericon },
    Teams: { title: "Teams", url: '/home/teams', icon: teamicon },
    ReportLog: { title: "Report Log", url: '/home/report', icon: plansicon },
};